import React from 'react';
import "./styles/accountDetails.css";

const AccountDetailsStep = ({ formData, updateFormData, showPassword, setShowPassword, setFormData }) => {
  const [passwordMatch, setPasswordMatch] = React.useState(true);

  const handlePasswordChange = (e) => {
    updateFormData('password', e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    updateFormData('repeatPassword', e.target.value);
    validatePassword(formData.password, e.target.value);
  };

    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const validatePassword = (password, confirmPassword) => {
      setPasswordMatch(password === confirmPassword);
    };

    return (
      <div className="step-content account-step">
      <h2>Account Details</h2>
      <input
        type="email"
        value={formData.email}
        onChange={(e) => {
        e.preventDefault();
        updateFormData('email', e.target.value);
        }}
        placeholder="Enter email"
      />
      <div className="register-password-group">
        <input
        type={showPassword ? "text" : "password"}
        value={formData.password}
        onChange={handlePasswordChange}
        placeholder="Enter password"
        />
        <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setShowPassword(!showPassword);
        }}
        >
        {showPassword ? "Hide" : "Show"}
        </button>
      </div>
      <div className="register-password-group">
        <input
        type={showConfirmPassword ? "text" : "password"}
        value={formData.repeatPassword}
        onChange={handleConfirmPasswordChange}
        placeholder="Confirm password"
        />
        <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setShowConfirmPassword(!showConfirmPassword);
        }}
        >
        {showConfirmPassword ? "Hide" : "Show"}
        </button>
      </div>
      {!passwordMatch && <p className="error-message">Passwords do not match</p>}
      </div>
    );
  };

export default AccountDetailsStep;
